import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import NewPatientAdmission from './NewPatientAdmission';
import $ from 'jquery';
import ManageAdmission from './ManageAdmission';
import Payments from './Payments';
import ErrorBoundary from '../../ErrorBoundary';
import RiskRule from './RiskRuleForAdmission';
import RiskRuleForAdmission from './RiskRuleForAdmission';


class PatientAdmissionTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName"),
            projectId: null,
            hideBotStore: false,
            patientAdmissionHeading: ''
        }
        window.admissionsNavBarController = this;
    }

    componentDidMount() {
        this.paintPatientAdmissionHeading();
        if (!this.tabClickHandlerDefined) {
            this.tabClickHandlerDefined = true;
            $("#manage-admission,#new-patient-admission,#payments")
                .on("click", function () {
                    $("#manage-admission,#new-patient-admission,#payments")
                        .removeClass('active');
                    localStorage.setItem("admissions-nav-bar-selection", $(this)[0].id);
                    $(this).addClass('active')
                });
        }
        this.markActiveTab();

    }

    markActiveTab() {
        $("#manage-admission,#new-patient-admission,#payments").removeClass('active');
        var defaultSelection = false;
        var savedNavBarSelection = localStorage.getItem("admissions-nav-bar-selection");
        var currentPath = window.location.href;
        if (currentPath.includes('/projectmgmt/patient-admission/add-patient') || currentPath.includes('/projectmgmt/patient-admission/add-patient/')) {
            defaultSelection = "new-patient-admission";
        } else if (currentPath.includes('/projectmgmt/patient-admission/payments') || currentPath.includes('/projectmgmt/patient-admission/payments/')) {
            defaultSelection = "payments";
        } else if (currentPath.includes('/projectmgmt/patient-admission') || currentPath.includes('/projectmgmt/patient-admission/')) {
            defaultSelection = "manage-admission";
        }
        if (defaultSelection !== false) {
            $("#patientNavMenu #" + defaultSelection).addClass('active');
            localStorage.setItem("admissions-nav-bar-selection", defaultSelection);
        } else {
            if (savedNavBarSelection) {
                $("#patientNavMenu #" + savedNavBarSelection).addClass('active');
            }

        }
    }

    paintPatientAdmissionHeading = () => {
        var healthSystemName = localStorage.getItem('healthSystemName');
        var hospitalName = localStorage.getItem('hospitalName');
        var serviceLineName = localStorage.getItem('serviceName');

        if (healthSystemName == "Select Health System" || healthSystemName == "null") {
            healthSystemName = null;
        }
        if ((hospitalName == "Select Hospital") || (hospitalName == "null")) {
            hospitalName = null;
        }
        if ((serviceLineName == "Select Service Line") || (serviceLineName == "null")) {
            serviceLineName = null;
        }

        var heading = "";
        if (healthSystemName) {
            heading = healthSystemName;
            if (hospitalName) {
                heading = hospitalName + " | " + heading;
                if (serviceLineName) {
                    heading = serviceLineName + " | " + heading;
                }
            }
        }
        this.state.patientAdmissionHeading = heading;
        this.setState(this.state);
    }

    render() {
        this.markActiveTab();
        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4" >
                                        <h1 className="m-0 page-title">{window.SCOPE_VALUE.CURRENT == 5 ? "Patients" : "Patient Enrollment"}</h1>
                                    </div>
                                    <div className="col-sm-8" style={{ textAlign: 'right' }}>
                                        <h1 className="m-0 page-title" style={{ textAlign: 'right' }}>
                                            {window.SCOPE_VALUE.CURRENT == 10 ? this.state.patientAdmissionHeading : this.state.showHomeEnityName}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid" >
                            <div className="border-bottom" style={{ marginLeft: '1vw' }}></div>
                            <div className="tab-class" style={{ marginLeft: '1vw' }}>

                                <ul className="nav nav-tabs border-bottom navCluster" id="patientNavMenu">
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/patient-admission" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="manage-admission" style={{ marginRight: '15px' }}>
                                            Manage Enrollments
                                        </li></Link>
                                    {/* <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/patient-admission/add-patient" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="new-patient-admission" style={{ marginRight: '15px' }}>
                                        New Enrollment
                                    </li></Link> */}
                                    {/* <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/patient-admission/payments" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="payments" style={{ marginRight: '15px' }}>
                                            Payments
                                        </li></Link> */}

                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/projectmgmt/patient-admission/add-patient" component={NewPatientAdmission}></Route>
                        <Route path="/projectmgmt/patient-admission/payments" component={Payments}></Route>
                        <Route path="/projectmgmt/patient-admission/risk-rule" component={RiskRuleForAdmission}></Route>
                        <Route path="/projectmgmt/patient-admission" component={ManageAdmission}></Route>
                    </Switch>
                </div>
            </ErrorBoundary>
        );
    }
}
export default PatientAdmissionTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientAdmissionTabSettings.js